import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CodeAssignmentConfiguration  {
    _originalTypeClassName = "zERP.BO.CodeAssignmentConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CodeAssignmentConfiguration.translate = translateService;
}
this.Segments = [];
this.BO = new Domain.AccountingSystemEntity();
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Entity:any;
Segments:any;
BO:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setSegments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Segments == null) $this.Segments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Segments.length > 0) {
                    Domain.CodeAssignmentConfiguration.removeSegments($this, $this.Segments[0]);
                }

                Domain.CodeAssignmentConfiguration.addManySegments($this, copyItems);
            }
static addManySegments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CodeAssignmentConfiguration.addSegments($this, items[i]);
                }
            }
static addSegments = ($this, item) => {
                if ($this.Segments == null) $this.Segments = [];
                if (item == null || $this.Segments.indexOf(item) > -1) return;
                $this.Segments.push(item);
}
static addRangeSegments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CodeAssignmentConfiguration.addSegments($this, item));
            }
static removeSegments = ($this, item) => {
                if ($this == null || $this.Segments == null || $this.Segments.indexOf(item) === -1) return;
                var _index = $this.Segments.indexOf(item);
                $this.Segments.splice(_index, 1);
}
static clearSegments = ($this) => { $this.Segments = null; }
static setBO = ($this, value) => {
var oldValue = $this.BO;
$this.BO = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}